/* eslint-disable react-hooks/exhaustive-deps */
import BaseExclusionView from '@bingads-webui-campaign-legacy/advanced-settings/view/base-exclusion';
import exclusionRepository from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import _ from 'underscore';
import { merge } from '@bingads-webui/primitive-utilities';
import { sharedStylesFromSelDesign } from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import React, { useContext, useCallback, useState, useEffect } from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { SpanWithComponent } from '@bingads-webui-campaign-react/wizard-shared-components';
import { useBackboneView } from '../shared';

const getStyles = () => ({
  '@global': merge(
    {},
    sharedStylesFromSelDesign()
  ),
  baseExclusionContainer: {
    '& .exclusion-wraper .row': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
});


const SiteExclusionView = ({ options }) => {
  const baseExclusionReactWrapper = useBackboneView(useCallback(() => new BaseExclusionView({
    exclusions: _.result(options.exclusions, 'ExcludedSites'),
    exclusionType: 'site',
    level: options.level,
    campaignExclusions: _.result(options.campaignExclusions, 'ExcludedSites'),
  }).render(), [options.campaignExclusions, options.exclusions, options.level]), options.setSiteExclusionView);
  return <>{baseExclusionReactWrapper}</>;
};
SiteExclusionView.propTypes = {
  options: PropTypes.shape({}).isRequired,
};
SiteExclusionView.defaultProps = {
};


const IPExclusionView = ({ options }) => {
  const baseExclusionReactWrapper = useBackboneView(useCallback(() => new BaseExclusionView({
    exclusions: _.result(options.exclusions, 'ExcludedIPs'),
    exclusionType: 'ip',
  }).render(), [options.exclusions]), options.setIPExclusionView);
  return <>{baseExclusionReactWrapper}</>;
};
IPExclusionView.propTypes = {
  options: PropTypes.shape({}).isRequired,
};
IPExclusionView.defaultProps = {};


// reference: private/campaign-legacy/packages/advanced-settings/view/advancedSettings.js
export const BaseExclusion = React.memo((props) => {
  const {
    patchData, setSiteExclusionView, setIPExclusionView, options: {
      level, campaignId, adgroupId, showSiteExclusion, showIPExclusion,
    },
  } = props;
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const baseExclusionText = i18n.getString(_TL_('Exclusions'));
  const exclusionDesc = _TL_('Which websites should not show your ads and which IP addresses should be blocked from seeing your ads?');
  const webSiteExclusionDesc = _TL_('Which websites should not show your ads?');

  let currentSiteExclusionView = null;
  let currentIPExclusionView = null;
  if (showSiteExclusion) {
    currentSiteExclusionView = <SiteExclusionView options={{ level, setSiteExclusionView }} />;
  }
  if (showIPExclusion) {
    currentIPExclusionView = <IPExclusionView options={{ setIPExclusionView }} />;
  }
  const [siteExclusion, setSiteExclusion] = useState(currentSiteExclusionView);
  const [IPExclusion, setIPExclusion] = useState(currentIPExclusionView);


  useEffect(() => {
    if (!campaignId) { return; }
    exclusionRepository.load(campaignId, adgroupId, level)
      .then(([campaignExclusions, adgroupExclusions]) => {
        const exclusions = level === 'campaign' ? campaignExclusions : adgroupExclusions;
        patchData('exclusions', exclusions);
        if (showSiteExclusion) {
          setSiteExclusion(<SiteExclusionView options={{
            level, campaignExclusions, exclusions, setSiteExclusionView,
          }}
          />);
        }
        if (showIPExclusion) {
          setIPExclusion(<IPExclusionView options={{ exclusions, setIPExclusionView }} />);
        }
      });
  }, [campaignId, adgroupId, level]);

  return (
    <div className={classnames(classes.baseExclusionContainer)}>
      <div className="camp-adg-shared-label">
        <SpanWithComponent
          SpanText={baseExclusionText}
          Component={() => (
            <HelpPopup
              topic="pop_BA_Settings_Exclusions"
              aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: baseExclusionText })}
            />)}
        />
      </div>
      <div className="exclusion-wraper">
        <div className="form-control-static">{i18n.getString(level === 'campaign' ? exclusionDesc : webSiteExclusionDesc)}</div>
        {showSiteExclusion && siteExclusion}
        {showIPExclusion && IPExclusion}
      </div>
    </div>
  );
});

BaseExclusion.propTypes = {
  patchData: PropTypes.func.isRequired,
  setSiteExclusionView: PropTypes.func.isRequired,
  setIPExclusionView: PropTypes.func,
  options: PropTypes.shape({}),
};

BaseExclusion.defaultProps = {
  options: {
  },
  setIPExclusionView() {},
};
